import {makeStyles, withStyles} from "@mui/styles";
import {
  amber,
  green,
  red,
  deepOrange,
  cyan,
  purple,
  grey,
  lightGreen,
} from "@mui/material/colors";
import {Chip} from "@mui/material";

export const useStyles = makeStyles({
  actions: {
    marginBottom: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 16,
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
});

export const ChipGreen = withStyles(theme => ({
  root: {
    backgroundColor: green[50],
    color: theme.palette.mode === 'dark' ? '#000' : theme.palette.text.primary,
    "&&:hover": {
      backgroundColor: green[100],
    },
    "&&:focus": {
      backgroundColor: green[100]
    }
  },
  deleteIcon: {
    color: theme.palette.mode === 'dark' ? 'rgba(41, 38, 33, 0.26)!important' : 'rgba(41, 38, 33, 0.26)!important'
  },
}))(Chip);


export const ChipYellow = withStyles(theme => ({
  root: {
    backgroundColor: amber[100],
    color: theme.palette.mode === 'dark' ? '#000' : theme.palette.text.primary,
    "&&:hover": {
      backgroundColor: amber[200],
    },
    "&&:focus": {
      backgroundColor: amber[200],
    }
  },
  deleteIcon: {
    color: theme.palette.mode === 'dark' ? 'rgba(41, 38, 33, 0.26)!important' : 'rgba(41, 38, 33, 0.26)!important'
  },
}))(Chip);

export const ChipRed = withStyles(theme => ({
  root: {
    backgroundColor: red[100],
    color: theme.palette.mode === 'dark' ? '#000' : theme.palette.text.primary,
    "&&:hover": {
      backgroundColor: red[200],
    },
    "&&:focus": {
      backgroundColor: red[200],
    }
  },
  deleteIcon: {
    color: theme.palette.mode === 'dark' ? 'rgba(41, 38, 33, 0.26)!important' : 'rgba(41, 38, 33, 0.26)!important'
  },
}))(Chip);

export const ChipDeepOrange = withStyles(theme => ({
  root: {
    backgroundColor: deepOrange[100],
    color: theme.palette.mode === 'dark' ? '#000' : theme.palette.text.primary,
    "&&:hover": {
      backgroundColor: deepOrange[200],
    },
    "&&:focus": {
      backgroundColor: deepOrange[200],
    }
  },
  deleteIcon: {
    color: theme.palette.mode === 'dark' ? 'rgba(41, 38, 33, 0.26)!important' : 'rgba(41, 38, 33, 0.26)!important'
  },
}))(Chip);

export const ChipCyan = withStyles(theme => ({
  root: {
    backgroundColor: cyan[100],
    color: theme.palette.mode === 'dark' ? '#000' : theme.palette.text.primary,
    "&&:hover": {
      backgroundColor: cyan[200],
    },
    "&&:focus": {
      backgroundColor: cyan[200],
    }
  },
  deleteIcon: {
    color: theme.palette.mode === 'dark' ? 'rgba(41, 38, 33, 0.26)!important' : 'rgba(41, 38, 33, 0.26)!important'
  },
}))(Chip);

export const ChipPurple = withStyles(theme => ({
  root: {
    backgroundColor: purple[100],
    color: theme.palette.mode === 'dark' ? '#000' : theme.palette.text.primary,
    "&&:hover": {
      backgroundColor: purple[200],
    },
    "&&:focus": {
      backgroundColor: purple[200],
    }
  },
  deleteIcon: {
    color: theme.palette.mode === 'dark' ? 'rgba(41, 38, 33, 0.26)!important' : 'rgba(41, 38, 33, 0.26)!important'
  },
}))(Chip);

export const ChipGrey = withStyles(theme => ({
  root: {
    backgroundColor: grey[100],
    color: theme.palette.mode === 'dark' ? '#000' : theme.palette.text.primary,
    "&&:hover": {
      backgroundColor: grey[200],
    },
    "&&:focus": {
      backgroundColor: grey[200]
    }
  },
  deleteIcon: {
    color: theme.palette.mode === 'dark' ? 'rgba(41, 38, 33, 0.26)!important' : 'rgba(41, 38, 33, 0.26)!important'
  },
}))(Chip);

export const ChipLightGreen = withStyles(theme => ({
  root: {
    backgroundColor: lightGreen[50],
    color: theme.palette.mode === 'dark' ? '#000' : theme.palette.text.primary,
    "&&:hover": {
      backgroundColor: lightGreen[100],
    },
    "&&:focus": {
      backgroundColor: lightGreen[100]
    }
  },
  deleteIcon: {
    color: theme.palette.mode === 'dark' ? 'rgba(41, 38, 33, 0.26)!important' : 'rgba(41, 38, 33, 0.26)!important'
  },
}))(Chip);
